// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCM_zDmSfQ7r8cWerOczeNaopBac9pwc2s",
    authDomain: "meuchavirtual.firebaseapp.com",
    databaseURL: "https://meuchavirtual-default-rtdb.firebaseio.com",
    projectId: "meuchavirtual",
    storageBucket: "meuchavirtual.appspot.com",
    messagingSenderId: "431111774485",
    appId: "1:431111774485:web:af75c34fd3797aee66091c",
  },
  rotaCasal: 'byanca-silva',
  bannerTop: '212px',
  usuarioFantasma: 'g@email.gm'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
